import localStorageFallback from 'local-storage-fallback';

export const storage = localStorageFallback;
